import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({ selector: '[appOutlined]', })
export class OutlinedDirective {
    constructor(
        private renderer: Renderer2,
        private el: ElementRef
    ) {}

    @HostListener('click')
    onClick() {
        const elements: HTMLCollection =
            document.getElementsByClassName('mat-icon-button');

        Array.from(elements).forEach(elements => {
            this.renderer.removeStyle(elements, 'border');
        });
        this.renderer.setStyle(this.el.nativeElement, 'border', 'none');
    }
}
